var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AppContent",class:{'is-end': _vm.inView}},[_vm._t("default"),_c('div',{ref:"contentEnd",staticClass:"AppContent-footer"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }